
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { State } from "vuex-class";

import { isUniversity } from "@/functions/userinterface.function";
import { SchoolModel } from "@/models/academy.model";

import ModalVideo from "@/components/landing/ModalVideo.vue";

@Component({
  filters: filters,
  components: {
    ModalVideo,
  },
})
export default class VideoTutorial extends Vue {
  /* VUEX */

  // ACTIONS

  /* INITIALIZATION */
  private videoShown: boolean = false;
  private vidioId: String = "";

  /* STATE */
  @State("locale")
  public locale: string;
  @State("school", { namespace: "academy" })
  private school: SchoolModel;

  constructor() {
    super();
  }

  /* LIFECYCLE */

  private created() {}

  private clickVideo(item: any) {
    this.vidioId = item.video_id;
    this.videoShown = !this.videoShown;
  }

  private getWording(item: any) {
    if (isUniversity(this.school.school_type)) {
      return this.$i18n.t(item.label_2);
    }

    return this.$i18n.t(item.label);
  }

  /**
   * https://developerx.atlassian.net/browse/CS-5361
   *
   * Created at : 21 Jan 2022           Updated at : 21 Jan 2022
   * Created by : Risman Abdilah        Updated by : Risman Abdilah
   *
   * Version 3.1.1
   */
  private dummy_array = [
    {
      label: "tutorial_for_bkk",
      label_2: "tutorial_for_bkk_2",
      video_id: "Eb-oDr8Hbsw",
    },
    {
      label: "tutorial_for_tracer_study",
      label_2: null,
      video_id: "neKRJXXzF4g",
    },
    {
      label: "career_support_indonesia_profile",
      label_2: null,
      video_id: "jrGlBRzpzRM",
    },
    {
      label: "tutorial_for_new_users",
      label_2: null,
      video_id: "lS63ccs5VZk",
    },
  ];
}
